import { GuestReservationDto } from 'gleblu-socket-api';
import { Action, createAction } from 'redux-act';

import { Reservation } from '../../../models/interfaces/reservation/Reservation';

export interface NewReservationRequestAnswer {
  accepted: boolean;
  guestUuid: string;
}

export interface ControlRequestArrived {
  requestArrived: boolean;
}

export type NewRequestReservationActionType = Action<NewReservationRequestAnswer, object>;

export const newRealTimeReservationRequest = createAction<GuestReservationDto>('NEW_RESERVATION_REQUEST');

export const acceptRealTimeReservation = createAction<Reservation>('ACCEPT_REAL_TIME_RESERVATION');

export const sendReservationRequestResponse = createAction<NewReservationRequestAnswer>('SEND_RESERVATION_REQUEST_RESPONSE');

export const sendRequestReservationAnswerError = createAction('SENT_RESERVATION_REQUEST_ERROR');

export const sendRequestReservationAnswerSuccess = createAction('SENT_RESERVATION_REQUEST_SUCCESS');

export const controlRequestArrived = createAction<ControlRequestArrived>('CONTROL_REQUEST_ARRIVED');
